import './index.css';

import { LicenseInfo } from '@mui/x-license-pro';
import ReactDOM from 'react-dom/client';

import App from './App';
import Config from './config/Config';

LicenseInfo.setLicenseKey(Config.MUI_LICENSE_KEY);

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
